export default {
  headers: {
    datetime: 'Data e Hora',
    company: 'Empresa',
    previous: 'Estado anterior',
    current: 'Estado atual',
    consultant: 'Gestora',
    comments: 'Observações'
  },
  title: 'Histórico de alterações da fatura'
}